// stores/authStore.ts
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { Hub } from "aws-amplify/utils";
import { User } from "@/lib/types";
import { api } from "@/lib/api";

interface AuthState {
  user: User | null;
  isLoading: boolean;
  error: string | null;
  fetchUser: () => Promise<void>;
  setUser: (user: User | null) => void;
  logout: () => void;
  initializeAuthListener: () => () => void; // Returns a function to cancel the listener
}

export const useAuthStore = create<AuthState>()(
  immer((set, get) => ({
    user: null,
    isLoading: false,
    error: null,
    fetchUser: async () => {
      set((state) => {
        state.isLoading = true;
        state.error = null;
      });
      try {
        const user = await api.getOrCreateUser();
        set((state) => {
          state.user = user;
          state.isLoading = false;
        });
      } catch (error) {
        set((state) => {
          state.error = "Failed to fetch user details";
          state.isLoading = false;
        });
        console.error("Error fetching user:", error);
      }
    },
    setUser: (user) =>
      set((state) => {
        state.user = user;
      }),
    logout: () =>
      set((state) => {
        state.user = null;
        state.error = null;
      }),
    initializeAuthListener: () => {
      const listener = Hub.listen("auth", ({ payload }) => {
        switch (payload.event) {
          case "signedIn":
            console.log("user have been signedIn successfully.");
            get().fetchUser();
            break;
          case "signedOut":
            console.log("user have been signedOut successfully.");
            get().logout();
            break;
          // You can add more cases as needed
        }
      });

      // Return a function to cancel the listener
      return () => listener();
    },
  }))
);

// Initialize the auth listener
const cancelAuthListener = useAuthStore.getState().initializeAuthListener();

// You might want to call this when your app unmounts or when you no longer need the listener
// cancelAuthListener();
